.table {
    border: none;
    border-collapse: collapse;
    width: 100%;

    & tbody {
        border-bottom: 1px solid var(--article-border);

        &:last-child {
            border-bottom: none;
        }

        & th,
        & td {
            border: none;
            padding: 0.5rem 0.75rem;
        }

        & th {
            font-weight: 700;
            /* 3b: dibdev aligns row titles to the top of their rowspan. */
            vertical-align: top;
            /* <th> browser default is center; row titles are left-aligned. */
            text-align: left;
            white-space: nowrap;
        }
    }

    & tbody tr:nth-child(even) {
        background-color: transparent;
    }
}

.headerVat {
    color: #22a3ab;
}

.headerAccounts {
    color: #89af00;
}

.headerPayroll {
    color: #bc5108;
}

.cellWrapper {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 1rem;
}

/* 3a: dibdev — 15px / 400 / #333 / capitalize, no letter-spacing. */
.debetCredit {
    font-size: 0.9375rem;
    font-weight: 400;
    color: #333;
    text-transform: capitalize;
    white-space: nowrap;
}

.taxRow {
    display: flex;
    align-items: baseline;
    gap: 0.5rem 0.75rem;
    flex-wrap: wrap;
    padding-top: 0.25rem;
    border-top: 1px solid var(--article-border-subtle);
}

/* 3c: tax pills bumped to 15px. */
.taxLink {
    color: inherit;
    cursor: pointer;
    text-underline-offset: 0.15em;
    text-decoration-thickness: 1px;
    font-size: 0.9375rem;
}

.taxTruthy {
    text-decoration: underline dotted;
}

/* 3d: strike-through tax pills keep body color, not muted gray. */
.taxFalsy {
    text-decoration: line-through;
    color: #333;
}
